/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  shopOrder.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:33
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {axiosAPIUrl, Parameter} from "./index";
import { PurchaseOrderDtlDto} from "@/api/buyCar";
import { AppendixFileDto } from '@/api/commonConfig'

/* 近一年订单统计信息列表数据类型 */
export class MonthCountListDto {
    month?: string;
    totalOrderCount?: number;
    totalOrderMoney?: number;
    totalReturnOrderCount?: number;
    totalReturnOrderMoney?: number;
}

/* 近一年订单统计信息列表数据类型，月份拼接年份 */
export class MonthCountListYearDto {
    month?: string;
    date?: string;
    totalOrderCount?: number;
    totalOrderMoney?: number;
    totalReturnOrderCount?: number;
    totalReturnOrderMoney?: number;
}

/* 订单统计汇总信息数据类型 */
export class CountOrderDto {
    totalOrderCount?: number;
    totalOrderMoney?: number;
    totalReturnOrderCount?: number;
    totalReturnOrderMoney?: number;
}

/* 获取订货单列表查询参数类型 */
export class OrderParamsDTO {
    companyId?: string;
    merchantId?: string;
    startTime?: string;
    endTime?: string;
    orderStatus?: string[];
    orderType?: number;
    payStatus?: number;
    pageIndex?: number;
    pageSize?: number;
}

/* 获取退货单列表查询参数类型 */
export class ReturnOrderParamsDTO {
    companyId?: string;
    startTime?: string;
    endTime?: string;
    returnOrderStatus?: string[];
    returnOrderType?: number;
    pageIndex?: number;
    pageSize?: number;
}

/* 退货单列表数据类型 */
export class ReturnOrderListDto {
    returnOrderId?: string;
    createTime?: string;
    shopCompanyId?: string;
    shopCompanyLogo?: string;
    shopCompanyName?: string;
    returnOrderType?: number;
    returnOrderMoney?: number;
    returnMoneySum?: number;
    returnOrderStatus?: number;
    returnOrderStatusName?: string;
    returnPayStatus?: string;
    returnPayStatusName?: string;
    packageCateAmount?: number;
    packageTotalQuantity?: number;
    currRouteId?: number;
}

/* 退货单详情数据类型 */
export class ReturnOrderInfoDto {
    shopCompanyId?: string;
    shopCompanyLogo?: string;
    shopCompanyName?: string;
    returnOrderId?: string;
    createTime?: string;
    returnOrderType?: number;
    returnMoneySum?: number;
    returnOrderStatus?: number;
    returnOrderStatusName?: string;
    returnPayStatus?: number;
    returnPayStatusName?: string;
    returnOrderMoney?: number;
    packageCateAmount?: number;
    packageTotalQuantity?: number;
    returnMan?: string;
    returnManBank?: string;
    returnManMobile?: string;
    receiveManBankNo?: string;
    currRouteId?: number;
    returnOrderRemarkList?: ReturnOrderRemarkDto[];
    orderDtlList?: OrderDtlListDto[];
    orderFileName?: string;
    orderFileUrl?: string;
    // nodeList?: NodeListDto[]
}

export class ReturnOrderRemarkDto {
    name?: string;
    orderRemark?: string;
    createTime?: string;
}

export class OrderDtlListDto {
    orderDtlId?: string;
    autoId?: string;
    salePrice?: number;
    saleAmount?: number;
    returnAmount?: number;
    orderMoney?: number;
    versionId?: string;
    goodsId?: string;
    goodsName?: string;
    goodsCode?: string;
    categoryId?: string;
    categoryName?: string;
    brandId?: string;
    brandName?: string;
    goodsMainImage?: string;
    packageId?: string;
    packageCode?: string;
    packageName?: string;
    packageNameDesc?: string;
    packageMainImage?: string;
    isMultiSpec?: boolean;
}

export class NodeListDto {
    orderId?: string;
    autoId?: string;
    isValid?: string;
    orderNodeId?: string;
}

/* 近一年订单统计信息列表 */
export function countOrderOfLastYearApp(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<MonthCountListDto[]>>({
        url: "/cykjorder/lookUp/countOrderOfLastYear",
        method: "get",
        params: parameter,
    });
}

/* 订单统计信息查询 */
export function countOrderApp(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<CountOrderDto>>({
        url: "/cykjorder/lookUp/countOrder",
        method: "get",
        params: parameter,
    });
}

/* 获取退货单列表 */
export function getReturnOrderList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<ReturnOrderListDto>>>({
        url: "/cykjorder/lookUp/getReturnOrderList",
        method: "post",
        data: parameter,
    });
}

/* 获取退货单详情 */
export function getReturnOrderInfo(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ReturnOrderInfoDto>>({
        url: "cykjorder/lookUp/getReturnOrderInfo",
        method: "post",
        data: parameter,
    });
}

/* 添加订/退单备注 */
export function addOrderRemark(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjorder/OM/addOrderRemark",
        method: "post",
        data: parameter,
    });
}

/* 订货单列表数据类型 */
export class ShopOrderListDto {
    /* 订单编号 */
    orderId?: string;
    /* 下单时间 */
    createTime?: string;
    /* 卖方企业编号 */
    shopCompanyId?: string;
    /* 卖方企业Logo */
    shopCompanyLogo?: string;
    /* 卖方企业名 */
    shopCompanyName?: string;
    /* 是否代下单 */
    orderType?: number;
    /* 应付金额 */
    orderMoney?: number;
    /* 订货单状态 */
    orderStatus?: number;
    /* 订货单状态中文描述 */
    orderStatusName?: string;
    /* 付款状态 */
    payStatus?: number;
    /* 付款状态中文描述 */
    payStatusName?: string;
    /* 套餐种类合计 */
    packageCateAmount?: number;
    /* 套餐数量合计 */
    packageTotalQuantity?: number;
    /* 分区序号 */
    currRouteId?: number;
}

/* 订货单详情数据类型 */
export class ShopOrderInfoDto {
    // 客户编码（买方公司）
    customerId?: string;
    // 配送方式
    distributionWay?: number;
    // 配送方式
    distributionWayName?: string;
    /* 卖方企业编号 */
    shopCompanyId?: string;
    /* 卖方企业Logo */
    shopCompanyLogo?: string;
    /* 卖方企业名 */
    shopCompanyName?: string;
    /* 订单编号 */
    orderId?: string;
    /* 下单时间 */
    createTime?: string;
    /* 是否代下单 */
    orderType?: number;
    /* 应付金额 */
    orderMoney?: number;
    /* 订货单状态 */
    orderStatus?: number;
    /* 订货单状态中文描述 */
    orderStatusName?: string;
    /* 付款状态 */
    payStatus?: number;
    /* 付款状态中文描述 */
    payStatusName?: string;
    /* 运费 */
    payFreight?: number;
    /* 订单金额合计 */
    orderTotalMoney?: number;
    /* 套餐种类合计 */
    packageCateAmount?: number;
    /* 套餐数量合计 */
    packageTotalQuantity?: number;
    /* 交货日期 */
    deliveryDate?: string;
    /* 收货地址 */
    receiveAddress?: string;
    /* 收货地址描述 */
    addressFullName?: string;
    /* 收货地址明细 */
    receiveAddressDtl?: string;
    /* 收货人手机 */
    receiveMobile?: string;
    /* 收货人 */
    receiveMan?: string;
    /* 分区序号 */
    currRouteId?: number;
    /* 是否可退货 */
    returnable?: boolean;
    /* 订单备注列表 */
    orderRemarkList?: ShopOrderRemarkListDto[];
    /* 订单明细列表 */
    // orderDtlList?: ShopOrderDtlListDto[];
    orderDtlList?: PurchaseOrderDtlDto[];
    /* 订单附件列表 */
    orderFileList?:AppendixFileDto[]
}

/* 订单备注列表数据类型 */
export class ShopOrderRemarkListDto {
    /* 订单备注-账号名 */
    remarkPersonName?: string;
    /* 订单备注-内容 */
    orderRemark?: string;
    /* 订单备注-时间 */
    createTime?: string;
}

/* 订单明细列表数据类型 */
export class ShopOrderDtlListDto {
    orderDtlId?: string;
    goodsMainImage?: string;
    packageId?: string;
    packageCode?: string;
    packageName?: string;
}

/* 获取订货单列表 */
export function getOrderInfoListApp(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<ShopOrderListDto>>>({
        url: "/cykjorder/lookUp/getOrderInfoList",
        method: "post",
        data: parameter,
    });
}

export class LoanOrderInfoDto extends ShopOrderListDto {
    /* 剩余可借款金额 */
    loanableAmount?: number;
    /* 订单已借款金额 */
    loanedAmount?: number;
    /* 订单借款金额 */
    orderTradeMoney?: number;
    /* 是否已选中 */
    isChecked: boolean;
}

/* 获取可借款的订货单列表信息 */
export function getLoanOrderInfoList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<Ajax.ListData<LoanOrderInfoDto>>>({
        url: "/cykjorder/lookUp/getLoanOrderInfoList",
        method: "post",
        data: parameter,
    });
}

/* 获取订货单详情 */
export function getOrderInfoApp(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ShopOrderInfoDto>>({
        url: "/cykjorder/lookUp/getOrderInfo",
        method: "post",
        data: parameter,
    });
}

/* 再次购买 */
export function purchaseGoodsAgain(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjorder/OM/purchaseGoodsAgain",
        method: "post",
        data: parameter,
    });
}

/* 确认收货 */
export function confirmRecieve(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjorder/OM/confirmRecieve",
        method: "post",
        data: parameter,
    });
}

/* 取消订单 */
export function cancelOrderApi(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjorder/OM/cancelOrder",
        method: "post",
        data: parameter,
    });
}

/* 订单节点列表数据类型 */
export class ShopOrderNodeListDto {
    nodeId?: string;
    nodeName?: string;
    createTime?: string;
}

/* 获取订单节点列表 */
export function getOrderNodeListAll(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ShopOrderNodeListDto[]>>({
        url: "/cykjorder/lookUp/getOrderNodeListAll",
        method: "post",
        data: parameter,
        extraParams: {showLoading: false}
    });
}

/* 确认收到退款 */
export function confirmRefund(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ShopOrderNodeListDto[]>>({
        url: "/cykjorder/OM/confirmRefund",
        method: "post",
        data: parameter,
    });
}

/* 取消退货单 */
export function cancelReturnOrderApi(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ShopOrderNodeListDto[]>>({
        url: "/cykjorder/OM/cancelReturnOrder",
        method: "post",
        data: parameter,
    });
}

/*  */
export class ReturnPackageListApi {
    /* 订单明细编号 */
    orderDtlId?: string;
    /* 版本编号 */
    versionId?: string;
    /* 商品编号 */
    goodsId?: string;
    /* 商品名称 */
    goodsName?: string;
    /* 商品编码 */
    goodsCode?: string;
    /* 套餐编号 */
    packageId?: string;
    /* 套餐编码 */
    packageCode?: string;
    /* 套餐主图 */
    mainImageUrl?: string;
    /* 套餐名 */
    packageName?: string;
    /* 套餐名 */
    packageNameDesc?: string;
    /* 单价 */
    salePrice?: number;
    /* 订购数量 */
    saleAmount?: number;
    /* 剩余可退货数量 */
    returnSaleAmount?: number;
    /* 是否已选中 */
    isChecked?: boolean;
    /* 是否是编辑数量效果 */
    isEdit?: boolean;
}

/* 获取可退套餐清单 */
export function getReturnablePackagesList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<ReturnPackageListApi[]>>({
        url: "/cykjorder/lookUp/getReturnablePackagesList",
        method: "post",
        data: parameter,
    });
}

/* 获取预提交退单信息入参数据类型 */
export class GetPreReturnOrderParamsDto {
    customerId?: string;
    orderId?: string;
    currRouteId?: string;
    returnOrderDtlList: { orderDtlId?: string; returnAmount?: number }[]
}

/* 获取预提交退单信息返回数据类型 */
export class PreRtnOrderInfoDto {
    companyId?: string;
    customerId?: string;
    orderMoney?: number;
    packageCateAmount?: number;
    packageTotalQuantity?: number;
    returnOrderDtlList?: ReturnOrderDtlDto[];
    orderDtlList?: ReturnOrderDtlDto[];
}

export class ReturnOrderDtlDto {
    orderDtlId?: string;
    versionId?: string;
    goodsId?: string;
    goodsName?: string;
    goodsCode?: string;
    packageId?: string;
    packageCode?: string;
    mainImageUrl?: string;
    packageMainImage?: string;
    packageName?: string;
    packageNameDesc?: string;
    salePrice?: number;
    saleAmount?: number;
    returnAmount?: number;
    returnSaleAmount?: number;
    orderMoney?: number;
}

/* 获取预提交退单信息 */
export function getPreRtnOrderInfo(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<PreRtnOrderInfoDto>>({
        url: "/cykjorder/OM/getPreRtnOrderInfo",
        method: "post",
        data: parameter,
    });
}

/* 提交退单 */
export function submitReturnOrder(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjorder/OM/submitReturnOrder",
        method: "post",
        data: parameter,
    });
}

/* 订单下退货套餐有效性校验 */
export function verifyReturnOrderDtl(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjorder/RO/verifyReturnOrderDtlApp",
        method: "post",
        data: parameter,
    });
}

export class AccountInfoDto {
    accountBank?: string;
    accountId?: string;
    accountName?: string;
}
